import React from 'react';

import { Text } from '@react-pdf/renderer';

import { Disease } from 'src/models/Disease.model';
import { Eye } from 'src/models/Eye.model';
import { Grading, GradingIsPositive } from 'src/models/Grading.model';
import { handleNSI18Next } from 'src/models/Language.model';
import { Session } from 'src/models/Session.model';

import { useHistoryResult } from 'src/hooks/useHistoryResult';

import { cls } from 'src/utils/reactPdfStyles';

export default function GradingSummaryText(
  session: Session,
  disease: Disease,
  historyIndex?: number,
) {
  const { handleCommonT } = handleNSI18Next();

  const { getHistoryResult } = useHistoryResult(session);

  const leftResult = getHistoryResult(Eye.LEFT, disease, historyIndex);
  const rightResult = getHistoryResult(Eye.RIGHT, disease, historyIndex);

  if (leftResult?.grading === undefined || rightResult?.grading === undefined) {
    return <Text style={cls('p')}></Text>;
  }

  if (disease === Disease.DR) {
    const rightDrGrading = rightResult?.gradable
      ? GradingIsPositive(rightResult.grading)
        ? Grading.POSITIVE
        : Grading.NEGATIVE
      : Grading.UNGRADEABLE;

    const leftDrGrading = leftResult?.gradable
      ? GradingIsPositive(leftResult.grading)
        ? Grading.POSITIVE
        : Grading.NEGATIVE
      : Grading.UNGRADEABLE;

    if (rightDrGrading === leftDrGrading) {
      return (
        <Text style={cls('p')}>
          {handleCommonT(`gradingSummaryText.${disease}.${rightDrGrading}.OU`)}
        </Text>
      );
    }

    return (
      <Text style={cls('p')}>
        {handleCommonT(`gradingSummaryText.${disease}.${rightDrGrading}.OD`)}{' '}
        {handleCommonT(`gradingSummaryText.${disease}.${leftDrGrading}.OS`)}
      </Text>
    );
  }

  if (leftResult.grading === rightResult.grading) {
    return (
      <Text style={cls('p')}>
        {handleCommonT(
          leftResult.gradable
            ? `gradingSummaryText.${disease}.${leftResult?.grading}.OU`
            : `gradingSummaryText.${disease}.ungradable.OU`,
        )}
      </Text>
    );
  }

  return (
    <Text style={cls('p')}>
      {handleCommonT(
        rightResult.gradable
          ? `gradingSummaryText.${disease}.${rightResult?.grading}.OD`
          : `gradingSummaryText.${disease}.ungradable.OD`,
      )}{' '}
      {handleCommonT(
        leftResult.gradable
          ? `gradingSummaryText.${disease}.${leftResult?.grading}.OS`
          : `gradingSummaryText.${disease}.ungradable.OS`,
      )}
    </Text>
  );
}
